import React from "react";
import { gql } from '@apollo/client';
import { Query } from "react-apollo";
import './posts.css';

type Post = {
    author: {
        node: {
            name: string;
        };
    };
    dateGmt: string;
    title: string;
    slug: string;
};

const Posts: React.FC = () => {
    const query = gql`
query getPosts {
  posts {
    nodes {
      author {
        node {
          name
        }
      }
      dateGmt
      title
      slug
    }
  }
}`;
    return (
        <div>
            <Query query={query}>
                {({ loading, error, data }) => {
                    if (loading) return <div id="loading"><p>Loading...</p></div>;
                    if (error) return <div id="error"><p>Error: {error.message}</p></div>;

                    return (
                        <div id="latest">
                            <h1>Latest</h1>
                            <div>
                                {data?.posts?.nodes?.map((post: Post, index: number) => (
                                    <div key={`post-${index}`} className="post">
                                        <span style={{fontSize:"1.4rem"}}>☞</span> <a href={`./posts/${post.slug}`}>{post.title}</a> {new Date(post.dateGmt).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'numeric',
                                        day: 'numeric',
                                    })} by {post.author.node.name   }
                                </div>
                            ))}
                            </div>
                        </div>
                    );
                }}
            </Query>
        </div>
    );
};

export default Posts;   